










import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class StepCheckByIcon extends Vue {
  @Prop({ default: 4 }) total!: number
  @Prop({ default: 1 }) step!: number
  @Prop() status!: string

  get stepColor() {
    return (['rejected', 'cancelled'].includes(this.status)) ? 'text-tes-orange' : 'text-tes-green'
  }
}
